export default "/images/locked-light.png?af49f52f3d688aebe745b7a076d8b64d";